export default "__VITE_ASSET__DOExsC2O__"